'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ImportAs = exports.EntryLink = exports.Property = exports.Markdown = exports.CodeBlock = exports.DocBlock = exports.Reexported = exports.DocListItem = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  padding-top: 8px;\n  padding-left: 24px;\n  padding-bottom: 8px;\n'], ['\n  padding-top: 8px;\n  padding-left: 24px;\n  padding-bottom: 8px;\n']);

exports.importPath = importPath;

var _path = require('path');

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _reactMarkdown = require('react-markdown');

var _reactMarkdown2 = _interopRequireDefault(_reactMarkdown);

var _reactPrism = require('react-prism');

var _reactRouterDom = require('react-router-dom');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = require('styled-material/dist/src/colors');

var _urls = require('../../lib/urls');

var _syntax = require('./syntax');

var _types = require('./types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var __assign = undefined && undefined.__assign || Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
    }
    return t;
};
var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
var DocListItem = exports.DocListItem = function DocListItem(_ref) {
    var item = _ref.item,
        apiDocs = _ref.apiDocs,
        children = _ref.children;
    return React.createElement("div", null, children, item.reexport && React.createElement(Reexported, { reexport: item.reexport, apiDocs: apiDocs }));
};
var Reexported = exports.Reexported = function Reexported(_ref2) {
    var reexport = _ref2.reexport,
        apiDocs = _ref2.apiDocs;

    var module = apiDocs.data.modules[reexport.path];
    if (!module) return React.createElement("span", null);
    return React.createElement("p", { style: { color: 'rgba(0, 0, 0, 0.54)' } }, "Exported from", ' ', React.createElement(_reactRouterDom.Link, { to: (0, _urls.moduleUrl)(module, apiDocs), style: { color: 'rgba(0, 0, 0, 0.54)', textDecoration: 'underline' } }, importPath(module, apiDocs)));
};
var DocBlock = exports.DocBlock = _styledComponents2.default.div(_templateObject);
var CodeBlock = exports.CodeBlock = function CodeBlock(_ref3) {
    var _ref3$language = _ref3.language,
        language = _ref3$language === undefined ? 'jsx' : _ref3$language,
        literal = _ref3.literal;
    return React.createElement("pre", null, React.createElement(_reactPrism.PrismCode, { className: 'language-' + language }, literal));
};
var Markdown = exports.Markdown = function Markdown(_a) {
    var style = _a.style,
        props = __rest(_a, ["style"]);
    return React.createElement("div", { style: style || { paddingTop: 8 } }, React.createElement(_reactMarkdown2.default, __assign({ escapeHtml: true, renderers: { CodeBlock: CodeBlock } }, props)));
};
var Property = exports.Property = function Property(_ref4) {
    var prop = _ref4.prop,
        showOptional = _ref4.showOptional,
        apiDocs = _ref4.apiDocs;
    return React.createElement("div", { style: { paddingTop: 4, paddingBottom: 4 } }, React.createElement("h5", null, React.createElement(_syntax.PropertyName, null, prop.name), showOptional && prop['optional'] && '?', prop.type && React.createElement("span", null, ": ", React.createElement(_types.Type, { type: prop.type, apiDocs: apiDocs }))), prop.documentation && React.createElement(DocBlock, null, React.createElement(Markdown, { source: prop.documentation })));
};
var EntryLink = exports.EntryLink = function EntryLink(_ref5) {
    var declaration = _ref5.declaration,
        module = _ref5.module,
        apiDocs = _ref5.apiDocs;
    return React.createElement(_reactRouterDom.Link, { to: (0, _urls.entryUrl)(declaration, module, apiDocs), style: { color: _colors.materialColors['indigo-500'] } }, declaration.name);
};
function importPath(module, apiDocs) {
    return module.outPath === apiDocs.data.mainModule ? apiDocs.data.name : (0, _path.join)(apiDocs.data.name, module.outPath).replace(/(?:\/index)?\.js$/, '');
}
var ImportAs = exports.ImportAs = function ImportAs(_ref6) {
    var declaration = _ref6.declaration,
        apiDocs = _ref6.apiDocs;

    var module = apiDocs.data.modules[apiDocs.data.declarationModule[declaration.id]];
    if (!module) return React.createElement("span", null);
    return React.createElement("div", null, declaration.exportedIn.map(function (e, i) {
        var module = apiDocs.data.modules[e.path];
        return React.createElement(ImportDirective, { key: i, name: e.name, path: importPath(module, apiDocs) });
    }), React.createElement(ImportDirective, { name: declaration.name, path: importPath(module, apiDocs) }));
};
var ImportDirective = function ImportDirective(_ref7) {
    var name = _ref7.name,
        path = _ref7.path;
    return React.createElement("div", { style: { paddingBottom: 4 } }, React.createElement(_syntax.Keyword, null, "import"), ' ', '{', name, '}', ' ', React.createElement(_syntax.Keyword, null, "from"), ' ', React.createElement(_syntax.StringLiteral, null, "'", path, "'"));
};
//# sourceMappingURL=docs.js.map



// WEBPACK FOOTER //
// ../documittu/packages/template/dist/components/ui/docs.js